import React from "react";
import { FieldWrapper } from "../../components/FieldWrapper";
import { Width } from "../configurables";
import { AutoFill } from "../configurables/AutoFill";
import { LabelInput } from "../inputFields/label";
import { ISubfields } from "../interfaces/ISubfields";
import { TableRow } from "./TableRow";

export class InventoryItemSelectTableRow extends TableRow implements ISubfields {
    public name = "inventory_item_select";
    public label = "LeistungsV";
    public icon = "archive";
    public fieldType = "Leistung";
    public subfields = [];
    public items;
    public attributeNames = ["items"];

    public getConfigurables() {
        return [Width, AutoFill];
    }

    public toHotColumn(): {} {
        return {
            type: "autocomplete",
            strict: false,
            source: [],
            visibleRows: 4,
            trimDropdown: false,
            field: {
                name: this.name,
                hashCode: this.hashCode,
                rawOptions: (this as any).rawOptions,
            },
        };
    }

    public EditComponent({ designer, schema, register, field, provided = null }) {
        return (
            <FieldWrapper
                register={register}
                provided={provided}
                field={field}
                schema={schema}
                designer={designer}
            >
                <div className="powerform-flex">
                    <div className="powerform-w50">
                        <label>Überschrift</label>
                        <LabelInput register={register} field={field} />
                    </div>
                </div>
            </FieldWrapper>
        );
    }
}
